module.exports = __webpack_public_path__ + "static/hornymascot-84bdb4ae305ad204aa1347d92cc923a3.png";